/**
 * Data layer for `four-payout-types-default-campaign-publisher-speci`. Thin typed fetch wrappers over /api/v1/four-payout-types-default-campaign-publisher-speci.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface FourPayoutTypesDefaultCampaignPublisherSpeciRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListFourPayoutTypesDefaultCampaignPublisherSpeciResponse {
	count: number;
	items: FourPayoutTypesDefaultCampaignPublisherSpeciRow[];
}

export interface CreateFourPayoutTypesDefaultCampaignPublisherSpeciBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/four-payout-types-default-campaign-publisher-speci";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListFourPayoutTypesDefaultCampaignPublisherSpeciResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListFourPayoutTypesDefaultCampaignPublisherSpeciResponse>(res);
}

export async function create(body: CreateFourPayoutTypesDefaultCampaignPublisherSpeciBody): Promise<FourPayoutTypesDefaultCampaignPublisherSpeciRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<FourPayoutTypesDefaultCampaignPublisherSpeciRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const fourPayoutTypesDefaultCampaignPublisherSpeciQueryKeys = {
	all: ["four-payout-types-default-campaign-publisher-speci"] as const,
	list: () => [...fourPayoutTypesDefaultCampaignPublisherSpeciQueryKeys.all] as const,
	detail: (id: string) => [...fourPayoutTypesDefaultCampaignPublisherSpeciQueryKeys.all, id] as const,
};
